import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../common/MediaQueries'
import { transition } from '../../../common/Mixins'
import { WithTheme } from '../../../setup/index'
import { FollowUsButtonsStylesProps } from './types'

const FollowUsButtonsListStyled = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${media.maxPhone} {
    flex-wrap: wrap;

    margin: 0 -2rem;
  }
`

const FollowUsButtonsListItemStyled = styled.li`
  @media ${media.maxPhone} {
    display: flex;
    justify-content: center;
    width: 50%;
    padding: 2rem;
  }
  @media ${media.phone} {
    margin: 0 3.125rem 1.25rem;
  }
`

const FollowUsButtonsLinkStyled = styled.a<WithTheme>`
  ${transition}
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  svg {
    ${transition}
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5.4375rem;
    height: 5.4375rem;
    opacity: 0.3;
  }

  &:hover {
    opacity: 1;
    svg {
      color: ${({ theme }) => theme.colors.green};
      opacity: 1;
    }
  }
`

const FollowUsButtonsStyled = styled.div<WithTheme<FollowUsButtonsStylesProps>>`
  width: 100%;

  ${({ isSmall }) =>
    isSmall &&
    css`
      ${FollowUsButtonsListStyled} {
        @media ${media.maxPhone} {
          justify-content: flex-start;
          margin: 0 -0.5rem;
        }
      }
      ${FollowUsButtonsListItemStyled} {
        @media ${media.maxPhone} {
          width: calc(100% / 5);
          padding: 0.5rem;
        }
        @media ${media.phone} {
          margin: 0 2.75rem 1.25rem 0;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      ${FollowUsButtonsLinkStyled} {
        svg {
          width: 2.4375rem;
          height: 2.4375rem;
        }
      }
    `};
`

export { FollowUsButtonsStyled, FollowUsButtonsListStyled, FollowUsButtonsListItemStyled, FollowUsButtonsLinkStyled }
